<script setup lang="ts">
import { RadioGroupIndicator, RadioGroupItem, RadioGroupRoot } from 'reka-ui'

const sortOrder = defineModel<{ value: string, label: string }>('sortOrder', {
  default: SORT_ORDER_OPTIONS[0],
})

const selectedSortValue = computed({
  get: () => sortOrder.value.value,
  set: (value: string) => {
    const selectedSort = SORT_ORDER_OPTIONS.find(option => option.value === value)
    if (selectedSort) {
      sortOrder.value = selectedSort
    }
  },
})
</script>

<template>
  <RadioGroupRoot
    v-model="selectedSortValue"
    class="flex flex-col gap-m"
    aria-label="Sort order selection"
  >
    <div
      v-for="item in SORT_ORDER_OPTIONS"
      :key="item.value"
      class="flex items-center gap-xs"
    >
      <RadioGroupItem
        :id="`sort-${item.value}`"
        :class="radioGroupVariants({ item: 'base' })"
        :value="item.value"
      >
        <RadioGroupIndicator :class="radioGroupVariants({ indicator: 'base' })" />
      </RadioGroupItem>
      <label
        class="text-primary text-small cursor-pointer"
        :for="`sort-${item.value}`"
      >
        {{ item.label }}
      </label>
    </div>
  </RadioGroupRoot>
</template>
